import { render, staticRenderFns } from "./DashCapNoneIcon.vue?vue&type=template&id=631aae53&"
import script from "./DashCapNoneIcon.vue?vue&type=script&lang=js&"
export * from "./DashCapNoneIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports